import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireAutosizeInput } from '../node_modules/react-input-autosize/lib/AutosizeInput.js';

var AutosizeInputExports = requireAutosizeInput();
var AutosizeInput = /*@__PURE__*/getDefaultExportFromCjs(AutosizeInputExports);

export { AutosizeInput as default };
